

import React, { useRef, useState, useEffect, useMemo } from "react";
import { Tag, Typography, Input, Button, Tabs, Modal, Select, Segmented } from "antd";
import { SearchOutlined, EyeInvisibleOutlined, CloseOutlined } from "@ant-design/icons";
//import './Reports.scss';
import PrimaryNav from "../../shared/PrimaryNav";
import PageHeader from "../../shared/PageHeader";
import sampleHotel from "./sampleBookingTMC.json";
import AgTableClient from "../../shared/AgTable/AgTableClient";
import './index.scss';
import Cleartrip from "../../assets/images/Cleartrip.jpg";
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';
import { useSearchParams } from "react-router-dom";
import ToolParamInvoker from "app/shared/AgTable/HelperTools/ToolParamInvoker";
import { useRecoilState } from "recoil";
import { currentPDFData } from "app/config/States/users";


const allRowData = sampleHotel;
console.log(allRowData, "row");

function HotelBookingTMC() {
    const [_, setCurrentPDFData] = useRecoilState(currentPDFData);
    const openSidebarRenderer = (params) => {
        console.log("pdf data:", params);
        setCurrentPDFData(params?.data);
        console.log("pdf data:", params?.data);
        params.api.openToolPanel("pdfRenderer", { paramData: params });
    };

    const columnDefs = [
  {
    headerName: "",
    field: "checkbox",
    checkboxSelection: true,
    headerCheckboxSelection: true,
    width: 50,
    pinned: 'left',
    lockPosition: true,
    suppressMovable: true,
    filter: false,
    sortable: false,
  },
  {
    headerName: "Trade Name",
    field: "tradeNm",
    filter: "agTextColumnFilter",
    formatType: "ENTITY",
    enableRowGroup: true,

  },
  {
    headerName: "Invoice",
    field: "INVOICE_LINK",
    filter: "agTextColumnFilter",
    invoiceLink: "html.pdf",
    cellRenderer: ToolParamInvoker,
    cellRendererParams: (params) => {
      return {
        label: "View Invoice",
        handleClick: openSidebarRenderer,
        data: params.data?.INVOICE_LINK || params?.value,
      };
    },
  },
  {
    headerName: "Supplier GSTIN",
    field: "Supplier GSTIN",
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "Document Number",
    field: "Document Number",
    filter: "agTextColumnFilter",
     enableRowGroup: true,
  },
  {
    headerName: "Corporate Name",
    field: "Corporate Name",
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "Corporate GSTIN",
    field: "Corporate GSTIN",
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "PAN",
    field: "PAN",
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "Supplier Legal Name",
    field: "Supplier Legal Name",
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "Document Date",
    field: "Document Date1",
    filter: "agDateColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "Total Taxable Value",
    field: "Total Taxable Value",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    formatType: "AMOUNT",
  },
  {
    headerName: "Total Tax Value",
    field: "Total Tax Value",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    formatType: "AMOUNT",
  },
  {
    headerName: "IGST Amount",
    field: "IGST Amount",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    formatType: "AMOUNT",
  },
  {
    headerName: "CGST Amount",
    field: "CGST Amount",
    enableRowGroup: true,
    filter: "agNumberColumnFilter",
    formatType: "AMOUNT",
  },
  {
    headerName: "SGST Amount",
    field: "SGST Amount",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    formatType: "AMOUNT",
  },
  {
    headerName: "CESS Amount",
    field: "CESS Amount",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    formatType: "AMOUNT",
  },
  {
    headerName: "Total Document Value",
    field: "Total Document Value",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "State Place of Supply",
    field: "State Place of Supply",
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "Same GSTIN",
    field: "same_gstin",
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "Total GST",
    field: "Total_GST",
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    formatType: "AMOUNT",
  },
  {
    headerName: "Status",
    field: "Status",
    filter: "agTextColumnFilter",
    cellRenderer: (params) => {
      const isAvailable = params.value === "Available";

      return (
        <span
          style={{
            color: isAvailable ? "green" : "red",
          }}
        >
          {params.value}
        </span>
      );
    }
  },
];

    const ref = useRef(null);
    const [searchParams] = useSearchParams();
    const [activeTab, setActiveTab] = useState("my data");
    const [rowData, setRowData] = useState(allRowData);
    const [isRunCampaignModalOpen, setIsRunCampaignModalOpen] = useState(false);
    const [campaignType, setCampaignType] = useState(null);
    const [frequency, setFrequency] = useState(null);
    const [hotel, setHotel] = useState([]);
    const [message1, setMessage1] = useState("");
    const [message2, setMessage2] = useState("");
    const [message3, setMessage3] = useState("");
    const [selectedCard, setSelectedCard] = useState(null);
    const [selectedRowsCount, setSelectedRowsCount] = useState(0);
    const [selectedRows, setSelectedRows] = useState([]); // State to store selected rows

    // Extract unique hotel names from selected rows only
    const hotelOptions = useMemo(() => {
        if (!selectedRows || selectedRows.length === 0) return []; // Return empty if no rows selected
        
        const selectedHotels = new Set();
        selectedRows.forEach(row => {
            // Check if row exists and has tradeNm property
            if (row && row.tradeNm) {
                let hotelName = row.tradeNm.trim();
                
                if (/\d+\./.test(hotelName)) {
                    const hotels = hotelName.split(/\d+\./).map(h => h.trim()).filter(h => h.length > 0);
                    hotels.forEach(hotel => selectedHotels.add(hotel));
                } 
                else if (hotelName.includes(',')) {
                    const hotels = hotelName.split(',').map(h => h.trim()).filter(h => h.length > 0);
                    hotels.forEach(hotel => selectedHotels.add(hotel));
                }
                else {
                    selectedHotels.add(hotelName);
                }
            }
        });
        
        return Array.from(selectedHotels)
            .sort()
            .map(hotel => ({
                label: hotel,
                value: hotel
            }));
    }, [selectedRows]); // Dependency on selectedRows

    useEffect(() => {
        const hotelName = searchParams.get('hotelName');
        if (hotelName) {
            // Filter data based on hotel name (Trade Name field)
            const filteredData = allRowData.filter(item => {
                const tradeName = item.tradeNm || item["Trade Name"] || "";
                return tradeName.toLowerCase().includes(hotelName.toLowerCase()) || 
                       hotelName.toLowerCase().includes(tradeName.toLowerCase());
            });
            setRowData(filteredData);
            
            // Apply filter to the table after a short delay to ensure grid is ready
            setTimeout(() => {
                if (ref.current && ref.current.setFilterModel) {
                    ref.current.setFilterModel({
                        tradeNm: {
                            type: 'contains',
                            filter: hotelName
                        }
                    });
                }
            }, 100);
        } else {
            setRowData(allRowData);
            // Clear filter if no hotel name
            setTimeout(() => {
                if (ref.current && ref.current.setFilterModel) {
                    ref.current.setFilterModel(null);
                }
            }, 100);
        }
    }, [searchParams]);

    const items = [
        {
            key: "1",
            label: "Recon A",
        },
        {
            key: "2",
            
            label: "Recon B",
        },
    ];

    const handleCardClick = (index) => {
        // Toggle selection - if same card is clicked, deselect it
        const newSelectedCard = selectedCard === index ? null : index;
        setSelectedCard(newSelectedCard);
        
        setTimeout(() => {
            if (ref.current && ref.current.setFilterModel) {
                const hotelName = searchParams.get('hotelName');
                let filterModel = {};
                
                // Add hotelName filter if it exists
                if (hotelName) {
                    filterModel.tradeNm = {
                        type: 'contains',
                        filter: hotelName
                    };
                }
                
                // If card was deselected, clear filters (except hotelName if exists)
                if (newSelectedCard === null) {
                    if (hotelName) {
                        ref.current.setFilterModel(filterModel);
                    } else {
                        ref.current.setFilterModel(null);
                    }
                } else if (newSelectedCard === 0) {
                    // Overview - only apply hotelName filter if exists, otherwise clear
                    if (hotelName) {
                        ref.current.setFilterModel(filterModel);
                    } else {
                        ref.current.setFilterModel(null);
                    }
                } else if (newSelectedCard === 1) {
                    // Invoices Uploaded - filter by "Available" status
                    filterModel.Status = {
                        type: 'equals',
                        filter: 'Available',
                        filterType: 'text'
                    };
                    ref.current.setFilterModel(filterModel);
                } else if (newSelectedCard === 2) {
                    // Invoices Pending - filter by "Not Available" status
                    filterModel.Status = {
                        type: 'equals',
                        filter: 'Not Available',
                        filterType: 'text'
                    };
                    ref.current.setFilterModel(filterModel);
                }
            }
        }, 200);
    };

    const cardsData = [
        {
            title: "Overview",
            hotels: 24,
            corporates:72,
            transactions: 118,
            gst: "₹20,54,465",
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M5.83317 10.8333C6.25365 10.8332 6.65864 10.992 6.96696 11.2779C7.27528 11.5638 7.46413 11.9557 7.49567 12.375L7.49984 12.5V15C7.49997 15.4205 7.34117 15.8255 7.05526 16.1338C6.76935 16.4421 6.37747 16.631 5.95817 16.6625L5.83317 16.6667H3.33317C2.91269 16.6668 2.5077 16.508 2.19938 16.2221C1.89106 15.9362 1.70221 15.5443 1.67067 15.125L1.6665 15V12.5C1.66637 12.0795 1.82518 11.6745 2.11108 11.3662C2.39699 11.0579 2.78887 10.869 3.20817 10.8375L3.33317 10.8333H5.83317ZM13.3332 14.1667C13.5456 14.1669 13.7499 14.2482 13.9043 14.394C14.0588 14.5398 14.1517 14.7391 14.1641 14.9512C14.1766 15.1632 14.1076 15.372 13.9713 15.5349C13.835 15.6977 13.6416 15.8024 13.4307 15.8275L13.3332 15.8333H9.99984C9.78744 15.8331 9.58314 15.7518 9.4287 15.606C9.27425 15.4602 9.18131 15.2609 9.16886 15.0488C9.15641 14.8368 9.2254 14.628 9.36172 14.4651C9.49805 14.3023 9.69142 14.1976 9.90234 14.1725L9.99984 14.1667H13.3332ZM16.6665 10.8333C16.8875 10.8333 17.0995 10.9211 17.2558 11.0774C17.412 11.2337 17.4998 11.4457 17.4998 11.6667C17.4998 11.8877 17.412 12.0996 17.2558 12.2559C17.0995 12.4122 16.8875 12.5 16.6665 12.5H9.99984C9.77882 12.5 9.56686 12.4122 9.41058 12.2559C9.2543 12.0996 9.1665 11.8877 9.1665 11.6667C9.1665 11.4457 9.2543 11.2337 9.41058 11.0774C9.56686 10.9211 9.77882 10.8333 9.99984 10.8333H16.6665ZM5.83317 2.5C6.2752 2.5 6.69912 2.67559 7.01168 2.98816C7.32424 3.30072 7.49984 3.72464 7.49984 4.16667V6.66667C7.49984 7.10869 7.32424 7.53262 7.01168 7.84518C6.69912 8.15774 6.2752 8.33333 5.83317 8.33333H3.33317C2.89114 8.33333 2.46722 8.15774 2.15466 7.84518C1.8421 7.53262 1.6665 7.10869 1.6665 6.66667V4.16667C1.6665 3.72464 1.8421 3.30072 2.15466 2.98816C2.46722 2.67559 2.89114 2.5 3.33317 2.5H5.83317ZM13.3332 5.83333C13.5456 5.83357 13.7499 5.9149 13.9043 6.06071C14.0588 6.20651 14.1517 6.40579 14.1641 6.61783C14.1766 6.82986 14.1076 7.03865 13.9713 7.20153C13.835 7.3644 13.6416 7.46908 13.4307 7.49417L13.3332 7.5H9.99984C9.78744 7.49976 9.58314 7.41843 9.4287 7.27263C9.27425 7.12682 9.18131 6.92754 9.16886 6.7155C9.15641 6.50347 9.2254 6.29468 9.36172 6.13181C9.49805 5.96893 9.69142 5.86425 9.90234 5.83917L9.99984 5.83333H13.3332ZM16.6665 2.5C16.8789 2.50024 17.0832 2.58157 17.2376 2.72737C17.3921 2.87318 17.485 3.07246 17.4975 3.2845C17.5099 3.49653 17.4409 3.70532 17.3046 3.86819C17.1683 4.03107 16.9749 4.13575 16.764 4.16083L16.6665 4.16667H9.99984C9.78744 4.16643 9.58314 4.0851 9.4287 3.93929C9.27425 3.79349 9.18131 3.59421 9.16886 3.38217C9.15641 3.17014 9.2254 2.96135 9.36172 2.79847C9.49805 2.6356 9.69142 2.53092 9.90234 2.50583L9.99984 2.5H16.6665Z" fill="#046666" />
                </svg>
            )
        },
        {
            title: "Invoices Uploaded",
            hotels: 18,
            corporates:50,
            transactions: 80,
            gst: "₹15,14,000",
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M9.43657 1.02734V7.17127C9.43657 8.2427 9.93871 8.75342 11.0101 8.75342H17.0705V16.3538C17.0705 18.0948 16.2084 18.9738 14.4755 18.9738H5.58621C3.86157 18.9738 2.99121 18.1034 2.99121 16.3538V3.65556C2.99121 1.91449 3.86157 1.02734 5.58585 1.02734H9.43657ZM13.7809 10.637C13.7145 10.5706 13.6358 10.518 13.5491 10.4821C13.4624 10.4462 13.3695 10.4277 13.2757 10.4277C13.1818 10.4277 13.0889 10.4462 13.0023 10.4821C12.9156 10.518 12.8368 10.5706 12.7705 10.637L8.92871 14.4791L8.40014 14.9409L7.91871 14.4791L6.57657 13.1373C6.44185 13.0072 6.26142 12.9352 6.07414 12.9369C5.88686 12.9385 5.7077 13.0136 5.57527 13.146C5.44283 13.2785 5.36771 13.4576 5.36609 13.6449C5.36446 13.8322 5.43646 14.0126 5.56657 14.1473L7.91871 16.4995C8.05266 16.6334 8.23431 16.7086 8.42371 16.7086C8.61311 16.7086 8.79476 16.6334 8.92871 16.4995L13.7809 11.647C13.9148 11.513 13.99 11.3314 13.99 11.142C13.99 10.9526 13.9148 10.7709 13.7809 10.637ZM10.5748 1.11913C10.9266 1.17806 11.278 1.42092 11.663 1.8227L16.2837 6.51842C16.6769 6.92842 16.9194 7.26342 16.9784 7.60663H11.0355C10.7337 7.60663 10.5748 7.45592 10.5748 7.15449V1.11913Z" fill="#10B981" />
                </svg>
            )
        },
        {
            title: "Invoices Pending",
            hotels: 6,
             corporates:22,
            transactions: 36,
            gst: "₹5,40,465",
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M10 2V6.5C10 6.89782 10.158 7.27936 10.4393 7.56066C10.7206 7.84196 11.1022 8 11.5 8H16V16.5C16 16.8978 15.842 17.2794 15.5607 17.5607C15.2794 17.842 14.8978 18 14.5 18H9.743C10.4899 17.0956 10.928 15.976 10.9935 14.8049C11.059 13.6338 10.7483 12.4724 10.1069 11.4903C9.46551 10.5083 8.52694 9.75702 7.42827 9.34623C6.32959 8.93544 5.12837 8.88666 4 9.207V3.5C4 3.10218 4.15804 2.72064 4.43934 2.43934C4.72064 2.15804 5.10218 2 5.5 2H10ZM11 2.25V6.5C11 6.63261 11.0527 6.75979 11.1464 6.85355C11.2402 6.94732 11.3674 7 11.5 7H15.75L11 2.25ZM10 14.5C10 15.6935 9.52589 16.8381 8.68198 17.682C7.83807 18.5259 6.69347 19 5.5 19C4.30653 19 3.16193 18.5259 2.31802 17.682C1.47411 16.8381 1 15.6935 1 14.5C1 13.3065 1.47411 12.1619 2.31802 11.318C3.16193 10.4741 4.30653 10 5.5 10C6.69347 10 7.83807 10.4741 8.68198 11.318C9.52589 12.1619 10 13.3065 10 14.5ZM5.5 12C5.36739 12 5.24021 12.0527 5.14645 12.1464C5.05268 12.2402 5 12.3674 5 12.5V14.5C5 14.6326 5.05268 14.7598 5.14645 14.8536C5.24021 14.9473 5.36739 15 5.5 15C5.63261 15 5.75979 14.9473 5.85355 14.8536C5.94732 14.7598 6 14.6326 6 14.5V12.5C6 12.3674 5.94732 12.2402 5.85355 12.1464C5.75979 12.0527 5.63261 12 5.5 12ZM5.5 17.125C5.66576 17.125 5.82473 17.0592 5.94194 16.9419C6.05915 16.8247 6.125 16.6658 6.125 16.5C6.125 16.3342 6.05915 16.1753 5.94194 16.0581C5.82473 15.9408 5.66576 15.875 5.5 15.875C5.33424 15.875 5.17527 15.9408 5.05806 16.0581C4.94085 16.1753 4.875 16.3342 4.875 16.5C4.875 16.6658 4.94085 16.8247 5.05806 16.9419C5.17527 17.0592 5.33424 17.125 5.5 17.125Z" fill="#C00F0C" />
                </svg>
            )
        }
    ];

    return (
        <div
            style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
            }}
        >
             <PageHeader 
                         style={{height:'60px'}}
                         leftActions={
                            <div style={{ display: 'flex', alignItems: 'center',gap:'4px' }}>
                               <img src={Cleartrip}  style={{height:'40px',width:"40px"}} alt="Left Action" />
                                <div style={{display:'flex',flexDirection:'column',marginLeft:'4px'}}>
                                    <span style={{color:"#161922",fontSize: '16px'}}>Cleartrip</span>
                                    <span style={{color:"#7D7D82",fontSize: '12px'}}>1245 Grand Avenue, Ojai, CA</span>
                                </div>
                            </div>
                         }
                         rightActions={
                            <div style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="20" viewBox="0 0 15 20" fill="none">
                                            <path d="M14.6631 7.33592C14.6639 6.10038 14.3523 4.8847 13.7575 3.80179C13.1626 2.71888 12.3038 1.80386 11.2606 1.14172C10.2175 0.479582 9.02396 0.0918036 7.79086 0.0144022C6.55775 -0.0629992 5.32508 0.172487 4.20735 0.698988C3.08961 1.22549 2.12305 2.02593 1.39746 3.02596C0.671871 4.02599 0.210776 5.19317 0.0570051 6.4191C-0.0967659 7.64502 0.0617749 8.88993 0.517902 10.0382C0.974029 11.1864 1.71295 12.2008 2.66602 12.9871V19.333C2.66594 19.4467 2.69493 19.5585 2.75024 19.6578C2.80555 19.7571 2.88533 19.8406 2.98201 19.9004C3.07869 19.9602 3.18906 19.9942 3.30261 19.9993C3.41617 20.0044 3.52914 19.9804 3.63079 19.9295L7.33156 18.0833L11.0332 19.9337C11.126 19.9781 11.2277 20.0006 11.3306 19.9995C11.5074 19.9995 11.6769 19.9293 11.8019 19.8043C11.9269 19.6793 11.9971 19.5098 11.9971 19.333V12.9871C12.831 12.3002 13.5025 11.4373 13.9635 10.4603C14.4244 9.48323 14.6634 8.41624 14.6631 7.33592ZM1.33301 7.33592C1.33301 6.14951 1.68482 4.98976 2.34395 4.0033C3.00308 3.01684 3.93993 2.24799 5.03602 1.79398C6.13211 1.33996 7.33822 1.22117 8.50182 1.45263C9.66543 1.68408 10.7343 2.25539 11.5732 3.0943C12.4121 3.93321 12.9834 5.00205 13.2149 6.16566C13.4463 7.32926 13.3275 8.53537 12.8735 9.63146C12.4195 10.7276 11.6506 11.6644 10.6642 12.3235C9.67772 12.9827 8.51796 13.3345 7.33156 13.3345C5.74119 13.3327 4.21646 12.7001 3.0919 11.5756C1.96733 10.451 1.33478 8.92629 1.33301 7.33592ZM2.66602 7.33592C2.66602 6.41316 2.93965 5.51113 3.45231 4.74388C3.96496 3.97664 4.69362 3.37864 5.54614 3.02552C6.39865 2.6724 7.33674 2.58 8.24177 2.76002C9.14679 2.94004 9.97811 3.38439 10.6306 4.03688C11.2831 4.68937 11.7274 5.52069 11.9075 6.42571C12.0875 7.33074 11.9951 8.26882 11.642 9.12134C11.2888 9.97386 10.6908 10.7025 9.9236 11.2152C9.15635 11.7278 8.25432 12.0015 7.33156 12.0015C6.09459 12.0001 4.90866 11.5082 4.03399 10.6335C3.15932 9.75882 2.66735 8.57289 2.66602 7.33592Z" fill="#F0B100"/>
                                        </svg>
                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                            <span style={{ color: "#DC8225", fontSize: '14px', fontWeight: 600 }}>Hotel Bellweather</span>
                                            <span style={{ color: "#7D7D82", fontSize: '12px' }}>Top Performer</span>
                                        </div>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="20" viewBox="0 0 19 20" fill="none">
                                            <path d="M17.4167 0H1.58333C1.16341 0 0.76068 0.16857 0.463748 0.468628C0.166815 0.768685 0 1.17565 0 1.6V7.19998C0 12.472 2.52542 15.667 4.64411 17.419C6.92609 19.3049 9.1962 19.9449 9.29516 19.9719C9.43123 20.0094 9.57471 20.0094 9.71078 19.9719C9.80974 19.9449 12.0769 19.3049 14.3618 17.419C16.4746 15.667 19 12.472 19 7.19998V1.6C19 1.17565 18.8332 0.768685 18.5363 0.468628C18.2393 0.16857 17.8366 0 17.4167 0ZM14.0204 6.96598L8.47875 12.566C8.40523 12.6403 8.31791 12.6994 8.22181 12.7396C8.1257 12.7799 8.02268 12.8006 7.91865 12.8006C7.81461 12.8006 7.71159 12.7799 7.61548 12.7396C7.51938 12.6994 7.43207 12.6403 7.35854 12.566L4.98354 10.166C4.83499 10.0159 4.75154 9.81226 4.75154 9.59997C4.75154 9.38768 4.83499 9.18409 4.98354 9.03397C5.13209 8.88386 5.33357 8.79953 5.54365 8.79953C5.75373 8.79953 5.9552 8.88386 6.10375 9.03397L7.91667 10.869L12.8982 5.83398C12.9718 5.75966 13.0591 5.7007 13.1552 5.66047C13.2513 5.62024 13.3543 5.59954 13.4583 5.59954C13.5624 5.59954 13.6654 5.62024 13.7615 5.66047C13.8576 5.7007 13.9449 5.75966 14.0184 5.83398C14.092 5.90831 14.1503 5.99655 14.1901 6.09367C14.23 6.19078 14.2504 6.29487 14.2504 6.39998C14.2504 6.5051 14.23 6.60918 14.1901 6.7063C14.1503 6.80341 14.092 6.89165 14.0184 6.96598H14.0204Z" fill="#00A76F"/>
                                        </svg>
                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                            <span style={{ color: "#10B981", fontSize: '14px', fontWeight: 600 }}>The Grand Zenith</span>
                                            <span style={{ color: "#7D7D82", fontSize: '12px' }}>Biggest Mover</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="notification-wrapper">
                                    <div className="notification-box">
                                        <NotificationsActiveOutlinedIcon style={{ width: '20px', height: '20px', color: '#000' }} />
                                    </div>
                                    <div className="notification-dot"></div>
                                </div>
                            </div>
                        }
                         />
            <div className="header-section">
                <div className="header-content">
                    <Typography className="heading-text">Bookings</Typography>
                    <span className="subheading-text">Here’s what you need to focus on today</span>
                </div>
                <div className="my-segmented" style={{ display: "flex", gap: "8px" }}>
                        <Button
                        disabled={selectedRowsCount === 0}
                            style={{
                            color: selectedRowsCount > 0 ? 'white' : '#7D7D82',
                            borderColor: selectedRowsCount > 0 ? '#0a8394' : '#E1E6EA',
                            backgroundColor: selectedRowsCount > 0 ? '#0a8394' : '#F5F5F5',
                            cursor: selectedRowsCount > 0 ? 'pointer' : 'not-allowed'
                        }}
                        onClick={() => {
                            if (selectedRowsCount > 0) {
                                setIsRunCampaignModalOpen(true);
                            }
                        }}
                        >
                            Run Campaign
                        </Button>
                    <Button
                        style={{
                           color:'#0a8394',
                           borderColor:"#0a8394" ,
                           backgroundColor:'white'
                        }}
                    >
                        Export table
                    </Button>
                   

                    <Button
                         style={{
                           color:'#7D7D82',
                           borderColor:'#E1E6EA',
                           backgroundColor:'#F5F5F5'
                        }}
                        disabled
                    >
                        Download Invoices
                    </Button>
                </div>

            </div>

            <div className="detail-section">
                {cardsData.map((item, index) => (
                    <div 
                        className={`detail-card ${selectedCard === index ? 'active' : ''}`}
                        key={index}
                        onClick={() => handleCardClick(index)}
                        style={{ cursor: 'pointer' }}
                    >
                        <div className="card-content">

                            <div className="card-header">
                                <div
                                    className={
                                        index === 0
                                            ? "card-icon"
                                            : index === 1
                                                ? "card-icon1"
                                                : "card-icon2"
                                    }
                                >
                                    {item.icon}
                                </div>

                                <span className="card-title">{item.title}</span>
                            </div>

                            <div className="card-description">
                                <div className="description-item1">
                                    <span className="description-label" style={{ color: "#7D7D82" }}>
                                        No.of Hotels
                                    </span>
                                    <span className="description-value">{item.hotels}</span>
                                </div>

                                 <div className="description-item1">
                                    <span className="description-label" style={{ color: "#7D7D82" }}>
                                        No.of Corporates
                                    </span>
                                    <span className="description-value">{item.corporates}</span>
                                </div>

                                <div className="description-item1">
                                    <span className="description-label" style={{ color: "#7D7D82" }}>
                                        No.of Transactions
                                    </span>
                                    <span className="description-value">{item.transactions}</span>
                                </div>

                                <div className="description-item1">
                                    <span className="description-label" style={{ color: "#7D7D82" }}>
                                        Total GST Value
                                    </span>
                                    <span className="description-value">{item.gst}</span>
                                </div>
                            </div>

                        </div>
                    </div>
                ))}
            </div>


            {/* ag-Grid Table */}
            <div style={{ flex: 1, marginTop: "16px", marginLeft: "20px", marginRight: "20px" }}>
                <AgTableClient
                    columnDefs={columnDefs}
                    rowData={rowData}
                    ref={ref}
                    groupPanel
                    enablePdfViewer
                    pdfDataKey="INVOICE_LINK"
                    pdfV2
                    onSelectionChanged={(params) => {
                        const selectedNodes = params.api.getSelectedNodes();
                        let selectedData = [];
                        selectedNodes.forEach(node => {
                            if (node.group && node.childrenAfterFilter) {
                                // If it's a group node, add all its children's data
                                selectedData = selectedData.concat(node.childrenAfterFilter.map(child => child.data));
                            } else if (!node.group) {
                                // If it's a regular row node, add its data
                                selectedData.push(node.data);
                            }
                        });
                        setSelectedRows(selectedData);
                        setSelectedRowsCount(selectedData.length);
                    }}
                />
            </div>

            {/* Run Campaign Modal */}
            <Modal
                open={isRunCampaignModalOpen}
                onCancel={() => {
                    setIsRunCampaignModalOpen(false);
                    setCampaignType(null);
                    setFrequency(null);
                    setHotel([]);
                    setMessage1("");
                    setMessage2("");
                    setMessage3("");
                }}
                footer={null}
                closeIcon={null}
                width={600}
                className="run-campaign-modal"
                styles={{
                    content: {
                        padding: 0,
                        maxHeight: '90vh',
                        overflow: 'auto'
                    }
                }}
            >
                <div className="run-campaign-modal-content">
                    {/* Modal Header */}
                    <div className="run-campaign-modal-header">
                        <Typography className="run-campaign-modal-title">Run Campaign</Typography>
                        <CloseOutlined 
                            className="run-campaign-modal-close"
                            onClick={() => {
                                setIsRunCampaignModalOpen(false);
                                setCampaignType(null);
                                setFrequency(null);
                                setHotel([]);
                                setMessage1("");
                                setMessage2("");
                                setMessage3("");
                            }}
                        />
                    </div>

                    {/* Modal Body */}
                    <div className="run-campaign-modal-body">
                        {/* Campaign Type Section */}
                        <div className="run-campaign-section">
                            <Typography className="run-campaign-section-title">Campaign Type</Typography>
                            <Select
                                placeholder="Choose a category"
                                value={campaignType}
                                onChange={setCampaignType}
                                style={{ width: '100%', marginTop: '8px' }}
                                suffixIcon={<span style={{ color: '#7D7D82' }}>▼</span>}
                                options={[
                                    { label: 'Reminder Campaign', value: 'reminder' },
                                    { label: 'Follow-up', value: 'follow-up' },
                                    { label: 'Escalation Request', value: 'escalation' },
                                    { label: 'Approval Request', value: 'approval' },
                                ]}
                            />
                            <Typography className="run-campaign-info-text" style={{ marginTop: '8px' }}>
                                Run campaign for {selectedRowsCount} selected transactions
                            </Typography>
                        </div>

                        {/* Frequency Section */}
                        <div className="run-campaign-section" style={{ marginTop: '24px' }}>
                            <Typography className="run-campaign-section-title">Frequency</Typography>
                            <Select
                                placeholder="Select frequency"
                                value={frequency}
                                onChange={(value) => {
                                    setFrequency(value);
                                    // Clear messages when frequency is cleared
                                    if (!value) {
                                        setMessage1("");
                                        setMessage2("");
                                        setMessage3("");
                                    }
                                }}
                                style={{ width: '100%', marginTop: '8px' }}
                                suffixIcon={<span style={{ color: '#7D7D82' }}>▼</span>}
                                options={[
                                    { label: 'Daily', value: 'daily' },
                                    { label: 'Weekly', value: 'weekly' },
                                    { label: 'Monthly', value: 'monthly' },
                                    { label: 'Quarterly', value: 'quarterly' },
                                ]}
                            />
                        </div>

                        {/* Hotel Section */}
                        <div className="run-campaign-section" style={{ marginTop: '24px' }}>
                            <Typography className="run-campaign-section-title">Hotel</Typography>
                            <Select
                                placeholder="Select hotel(s)"
                                value={hotel}
                                onChange={setHotel}
                                style={{ width: '100%', marginTop: '8px' }}
                                suffixIcon={<span style={{ color: '#7D7D82' }}>▼</span>}
                                showSearch
                                filterOption={(input, option) =>
                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                                options={hotelOptions}
                                dropdownStyle={{ maxHeight: '200px', overflow: 'auto' }}
                                listHeight={200}
                                virtual={false}
                                mode="multiple"
                                maxTagCount="responsive"
                            />
                        </div>

                        {/* Message fields - only show when frequency is selected */}
                        {frequency && (
                            <>
                                {/* Message 1 Section */}
                                <div className="run-campaign-section" style={{ marginTop: '24px' }}>
                                    <Typography className="run-campaign-section-title">Message 1</Typography>
                                    <Input
                                        placeholder="Enter first message"
                                        value={message1}
                                        onChange={(e) => setMessage1(e.target.value)}
                                        style={{ marginTop: '8px' }}
                                    />
                                </div>

                                {/* Message 2 Section */}
                                <div className="run-campaign-section" style={{ marginTop: '24px' }}>
                                    <Typography className="run-campaign-section-title">Message 2</Typography>
                                    <Input
                                        placeholder="Enter second message"
                                        value={message2}
                                        onChange={(e) => setMessage2(e.target.value)}
                                        style={{ marginTop: '8px' }}
                                    />
                                </div>

                                {/* Message 3 Section */}
                                <div className="run-campaign-section" style={{ marginTop: '24px' }}>
                                    <Typography className="run-campaign-section-title">Message 3</Typography>
                                    <Input
                                        placeholder="Enter third message"
                                        value={message3}
                                        onChange={(e) => setMessage3(e.target.value)}
                                        style={{ marginTop: '8px' }}
                                    />
                                </div>
                            </>
                        )}
                    </div>

                    {/* Modal Footer */}
                    <div className="run-campaign-modal-footer">
                        <Button
                            onClick={() => {
                                setIsRunCampaignModalOpen(false);
                                setCampaignType(null);
                                setFrequency(null);
                                setHotel([]);
                                setMessage1("");
                                setMessage2("");
                                setMessage3("");
                            }}
                            style={{
                                borderColor: '#E1E6EA',
                                color: '#161922',
                                backgroundColor: 'white'
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={() => {
                                // Handle run campaign logic here
                                console.log('Running campaign:', { campaignType, frequency, hotel, message1, message2, message3 });
                                setIsRunCampaignModalOpen(false);
                                setCampaignType(null);
                                setFrequency(null);
                                setHotel([]);
                                setMessage1("");
                                setMessage2("");
                                setMessage3("");
                            }}
                            style={{
                                borderColor: '#0a8394',
                                color: 'white',
                                backgroundColor: '#0a8394'
                            }}
                        >
                            Run Campaign
                        </Button>
                    </div>
                </div>
            </Modal>
        </div>
    );
}

export default HotelBookingTMC;

